import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EditableItem, ModuleFE_Dialog, ModuleFE_Toaster, StorageKey, TS_Dialog, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import './Component_SupportReport.scss';
import { exists } from '@nu-art/ts-common';
import { DefaultEditor_InputText_Optional, DefaultEditor_TextArea } from '@app/styles/frontend/ui-manager/ui-components';
import { supportType_Feedback } from '@app/advisor-shared';
import { ModuleFE_Advisor_EHREnvironment, ModuleFE_Advisor_Facility, ModuleFE_AdvisorSession, ModuleFE_EMInterface, ModuleFE_EncounterStorage } from '@app/advisor-frontend';
import { ModuleFE_AdvisorAnalytics } from '../../../_analytics/consts.js';
const StorageKey_SupportTicket = 'storage-support-ticket';
export class Component_SupportReport extends TS_Dialog {
    //######################### Static #########################
    static defaultProps = {
        dialogId: 'support-ticket-dialog',
    };
    static show = (props) => {
        ModuleFE_Dialog.show({ content: _jsx(Component_SupportReport, { ...props }) });
        //Report analytics event
        ModuleFE_AdvisorAnalytics.trigger.bugReport.bugReport_open();
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        const facilityId = ModuleFE_AdvisorSession.getCurrentFacilityId();
        const facility = ModuleFE_Advisor_Facility.cache.unique(facilityId);
        const environmentId = ModuleFE_AdvisorSession.getCurrentEHREnvironmentId();
        const environment = ModuleFE_Advisor_EHREnvironment.cache.unique(environmentId);
        if (!environment && !facility) {
            ModuleFE_Toaster.toastError('No data was found. cannot send bug');
            ModuleFE_Dialog.close();
            return state;
        }
        state.ticket ??= this.getEditable(nextProps.type, facility, environment);
        return state;
    }
    //######################### Logic #########################
    getEditable(type, facility, ehrEnvironment) {
        const dataVersion = new StorageKey('storage__artifact-version').get();
        const supportTicketStorage = ModuleFE_EncounterStorage.getStorageKey(StorageKey_SupportTicket);
        const defaultTicket = supportTicketStorage.get({
            type: type,
            dataVersion: dataVersion ?? '0.0.0',
            actualBehaviorMessage: '',
            expectedBehaviorMessage: '',
            reportingUser: '',
            facilityName: facility?.name,
            environmentName: ehrEnvironment?.label
        });
        return new EditableItem(defaultTicket)
            .setSaveAction(async (ticket) => ticket)
            .setOnChanged(async () => {
            supportTicketStorage.set(this.state.ticket.item);
            this.forceUpdate();
        });
    }
    submitTicket = async () => {
        const isAvatar = ModuleFE_AdvisorSession.getIsAvatar() ?? false;
        const ticket = this.state.ticket.item;
        ticket.reportingUser = isAvatar ? ticket.reportingUser + ' (Avatar Mode)' : ticket.reportingUser;
        const response = await ModuleFE_EMInterface.submitSupportTicket(ticket);
        if (!response) {
            const message = ticket.type === supportType_Feedback ? 'Feedback sent successfully' : 'Bug report sent successfully';
            ModuleFE_EncounterStorage.getStorageKey(StorageKey_SupportTicket).delete();
            ModuleFE_Toaster.toastSuccess(message);
            ModuleFE_AdvisorAnalytics.trigger.bugReport.bugReport_submit();
        }
        else {
            ModuleFE_Toaster.toastError('An error occurred. The bug report could not be sent.');
        }
        this.closeDialog();
    };
    //######################### Render #########################
    renderHeader = () => {
        const type = this.state.ticket.item.type;
        return type === supportType_Feedback ? 'Send Feedback' : 'Report A Bug';
    };
    renderBody = () => {
        return _jsxs(_Fragment, { children: [this.renderBody_ReportingUser(), this.renderBody_ActualMessage(), this.renderBody_ExpectedMessage(), this.renderBody_Disclaimer()] });
    };
    renderBody_ExpectedMessage = () => {
        const ticket = this.state.ticket;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Expected Behavior', children: _jsx(DefaultEditor_TextArea, { editable: ticket, prop: 'expectedBehaviorMessage', placeholder: 'What I expected...', saveEvent: ['change', 'blur'] }) });
    };
    renderBody_ActualMessage = () => {
        const ticket = this.state.ticket;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Actual Behavior', children: _jsx(DefaultEditor_TextArea, { editable: ticket, prop: 'actualBehaviorMessage', placeholder: 'What actually happened...', saveEvent: ['change', 'blur'] }) });
    };
    renderBody_Disclaimer = () => {
        return _jsxs("p", { className: 'support-ticket__disclaimer', children: [_jsx("b", { children: "Note:" }), " Please refrain from including any patient's personal identifying information."] });
    };
    renderBody_ReportingUser = () => {
        const ticket = this.state.ticket;
        return _jsx(TS_PropRenderer.Horizontal, { label: 'Reporting User (Optional)', children: _jsx(DefaultEditor_InputText_Optional, { editable: ticket, prop: 'reportingUser' }) });
    };
    buttons = () => {
        const actualBehaviorMessage = this.state.ticket.item.actualBehaviorMessage;
        const disabled = !exists(actualBehaviorMessage) || actualBehaviorMessage.length < 3;
        return {
            right: [
                {
                    content: 'Cancel',
                    variant: 'secondary',
                    className: 'back-btn',
                    onClick: () => {
                        this.closeDialog();
                        ModuleFE_AdvisorAnalytics.trigger.bugReport.bugReport_abandon();
                    },
                },
                {
                    content: 'Submit',
                    variant: 'primary',
                    disabled: disabled,
                    onClick: this.submitTicket,
                },
            ]
        };
    };
}
//# sourceMappingURL=Component_SupportReport.js.map